import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    cartItems: {}, // key: product.id, value: product details + quantity
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        // Add or increment item in cart
        addToCart: (state, action) => {
            const product = action.payload;
            const id = product.id;

            if (!state.cartItems[id]) {
                state.cartItems[id] = {
                    ...product,
                    quantity: product.quantity || 1,
                    minQuantity: product.quantity || 1,
                };
            } else {
                state.cartItems[id].quantity += 1;
            }
        },

        // Remove item from cart
        removeFromCart: (state, action) => {
            const id = action.payload.id;
            delete state.cartItems[id];
        },

        // Update specific quantity
        updateItemQuantity: (state, action) => {
            const { id, quantity } = action.payload;
            if (state.cartItems[id]) {
                state.cartItems[id].quantity = quantity;
            }
        },

        // Clear entire cart
        clearCart: (state) => {
            state.cartItems = {};
        },
    },
});

export const {
    addToCart,
    removeFromCart,
    updateItemQuantity,
    clearCart
} = cartSlice.actions;

export default cartSlice.reducer;

//
// SELECTORS
//

// All cart items as array
export const selectCartItems = (state) =>
    Object.values(state.cart.cartItems);

// Total quantity in cart
export const selectTotalItemCount = (state) =>
    Object.values(state.cart.cartItems).reduce((sum, item) => sum + item.quantity, 0);

// Total specific item in cart
export const selectTotalUniqueItems = (state) =>
    Object.keys(state.cart.cartItems).length;

// Total price in cart
export const selectTotalPrice = (state) =>
    Object.values(state.cart.cartItems).reduce((total, item) => total + item.price * item.quantity, 0);
